import React, { useEffect, useState, useRef } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';

import * as Yup from 'yup';
import { LOGOUT } from 'ConstComponents';
import {
    AddBeneficiary as INSERT,
    SelectBank as BANK_SELECT
} from 'Components/Api/CreditInstitutionSettingAPI';
import CircularProgress from '@material-ui/core/CircularProgress';
import {
    Container,
    Grid,

} from '@material-ui/core';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import {
    PLEASE_PROVIDE_VALID
} from 'Components/Helper/Messages';

import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';

import HOCLoader from 'Components/Loader/HOCLoader';
import Accordion from '@material-ui/core/Accordion';
import HOCAccordion from 'Components/CustomAccordion/HOCAccordion';
import {
    PrimaryButton,
    SecondaryButton
} from 'Components/Inputes/CustomButton';
import { AutoCompleteTextView } from 'Components/Inputes/AutoCompleteTextView';
const CustomAccordion = HOCAccordion(Accordion);
const CustomContainer = HOCLoader(Container);

export const AddBeneficiary = () => {
    const formRef = useRef();

    const [loadingOpen, setLoadingOpen] = React.useState(false);
    const classes = commonStyle();
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [openFilter, setOpenFilter] = useState(true);
    const [bankList, setBankList] = useState([]);
    const [loading, setLoading] = useState(false);


    const [formObj, setFormObj] = useState({
        IFSCCode: '',
        bankName: '',
        AccNo: '',
        Name: '',
        BranchName: '',
        TransferLimit: '',
        MobileNo: '',
        ConfirmAccNo: ''

    });

    const formValidationSchema = Yup.object({

        IFSCCode: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'IFSC')
            .length(11, PLEASE_PROVIDE_VALID + 'IFSC'),

        AccNo: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'account number')
            .min(7, PLEASE_PROVIDE_VALID + 'account number')
            .max(20, PLEASE_PROVIDE_VALID + 'account number'),

        ConfirmAccNo: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'confirm account number')
            .min(7, PLEASE_PROVIDE_VALID + 'account number')
            .max(20, PLEASE_PROVIDE_VALID + 'account number')
            .oneOf([Yup.ref('AccNo'), null], "Account number don't match"),

        MobileNo: Yup.string().required(
            PLEASE_PROVIDE_VALID + 'mobile number'
        ),

        Name: Yup.string().required(PLEASE_PROVIDE_VALID + 'Name'),

        BranchName: Yup.string().required(
            PLEASE_PROVIDE_VALID + 'Branch Name'
        ),

        TransferLimit: Yup.string().required(PLEASE_PROVIDE_VALID + 'Transfer Limit'),

    });
    useEffect(() => {
        selectBankList();

    }, []);

    const reset = () => {
        setFormObj({

            IFSCCode: '',
            bankName: '',
            AccNo: '',
            Name: '',
            TransferLimit: '',
            MobileNo: '',
            ConfirmAccNo: '',
            BranchName: ''
        });
    };

    const selectBankList = async () => {
        setLoading(true);
        const response = await BANK_SELECT();

        if (!response.isAuthorized) {
            LOGOUT();
        }
        if (!response.status) {
            setResponseMessage(response.data);
            setIsError(true);
            return;
        }
        const data = JSON.parse(response.data);

        if (!data.Banks || !Array.isArray(data.Banks)) {
            setResponseMessage("Invalid bank list format");
            setIsError(true);
            return;
        }

        setBankList(data.Banks);
    };

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        if (loadingOpen) return;
        var jsonReq = {
            IFSCCode: values.IFSCCode,
            bankName: values.Bank?.bankName,
            BranchName: values.BranchName,
            AccNo: values.AccNo,
            Name: values.Name,
            MobileNo: values.MobileNo,
            TransferLimit: values.TransferLimit,
        };

        setIsError(false);
        var requestObj = JSON.stringify(jsonReq);
        setLoadingOpen(true);

        var response = await INSERT(requestObj);

        setLoadingOpen(false);

        if (!response.isAuthorized) LOGOUT();
        setSeverity('success');
        setResponseMessage(response.data);
        setIsError(true);
        if (!response.status) {
            setSeverity('error');
            return;
        }

        reset();
        resetForm();
    };

    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                innerRef={formRef}
                enableReinitialize={true}
                initialValues={formObj}
                validationSchema={formValidationSchema}
                onSubmit={handleSubmit}
                resetForm={formObj}
                render={({ values, setFieldValue, handleSubmit }) => {
                    return (
                        <Form style={{ marginBottom: '15px' }}>
                            <Grid item xs={12}>
                                <CustomAccordion
                                    title={'Add Beneficiary'}
                                    open={openFilter}
                                    setOpen={(value) => setOpenFilter(value)}
                                >
                                    <Grid container spacing={3}>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <Field
                                                component={AutoCompleteTextView}
                                                name="Bank"
                                                options={bankList}
                                                getOptionLabel={(option) => option.bankName}
                                                getOptionSelected={(option, value) => option.bankName === value.bankName}
                                                textFieldProps={{
                                                    label: 'Bank'
                                                }}
                                                onCustomCallback={(name, value) => {
                                                    setFieldValue('IFSC', value.ifscCode);
                                                    setFieldValue('Bank.bankName', value.bankName);
                                                    setFieldValue('Bank.bankId', value.bankId);
                                                }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialTextField
                                                label="IFSC Code"
                                                name="IFSCCode"
                                                type="text"
                                                placeholder="IFSC Code"
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialTextField
                                                label="Account No"
                                                name="AccNo"
                                                type="text"
                                                placeholder="Account No"
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialTextField
                                                label="Confirm Account No"
                                                name="ConfirmAccNo"
                                                type="text"
                                                placeholder="Confirm Account No"
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialTextField
                                                label="Account Holder Name"
                                                name="Name"
                                                type="text"
                                                placeholder="Account Holder Name"
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialTextField
                                                label="Branch Name"
                                                name="BranchName"
                                                type="text"
                                                placeholder="Branch Name"
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialTextField
                                                label="Transfer Limit"
                                                name="TransferLimit"
                                                type="text"
                                                placeholder="Transfer Limit"
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialTextField
                                                label="Mobile Number"
                                                name="MobileNo"
                                                type="text"
                                                placeholder="Mobile Number"
                                                length={10}
                                            />
                                        </Grid>

                                        <Grid
                                            container
                                            spacing={2}
                                            style={{
                                                justifyContent: 'flex-end',
                                                display: 'flex'
                                            }}
                                        >
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={12}
                                                lg={12}
                                                style={{
                                                    justifyContent: 'flex-end',
                                                    display: 'flex'
                                                }}
                                            >
                                                <Grid
                                                    container
                                                    spacing={2}
                                                    style={{
                                                        justifyContent: 'end',
                                                        marginBottom: '14px',
                                                        marginRight: '14px'
                                                    }}
                                                >
                                                    <Grid
                                                        item
                                                        xs={12}
                                                        sm={12}
                                                        md={1}
                                                        lg={1}
                                                    >
                                                        <PrimaryButton
                                                            type="submit"
                                                            title="Submit"
                                                            className={
                                                                classes.CustomPrimaryButtonStyle
                                                            }
                                                            disabled={
                                                                loadingOpen
                                                            }
                                                        >
                                                            Submit
                                                        </PrimaryButton>
                                                        {loadingOpen && (
                                                            <CircularProgress
                                                                size={24}
                                                                className={
                                                                    classes.buttonProgress
                                                                }
                                                            />
                                                        )}
                                                    </Grid>
                                                    <Grid
                                                        item
                                                        xs={12}
                                                        sm={12}
                                                        md={1}
                                                        lg={1}
                                                    >
                                                        <SecondaryButton
                                                            type="reset"
                                                            variant="contained"
                                                            color="secondary"
                                                            title="Reset"
                                                            className={
                                                                classes.CustomDangerButtonStyle
                                                            }
                                                            onClick={() => {
                                                                reset();
                                                            }}
                                                        >
                                                            Reset
                                                        </SecondaryButton>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </CustomAccordion>
                            </Grid>
                        </Form>
                    );
                }}
            />

        </CustomContainer>
    );
};
